module.exports = __webpack_public_path__ + "img/hexin1.24ea2417.png";